import React, { createContext, useEffect, useState, useContext } from 'react';
import { UserContext } from './UserContext';

export const ShowAllFacilitiesContext = createContext();

export const ShowAllFacilitiesProvider = (props) => {

    const { user } = useContext(UserContext);

    const [showAllFacilities, setShowAllFacilities] = useState(false);

    useEffect(() => {
        const localVal = localStorage.getItem('widget_showAllFacilities_Show');
        if (localVal !== null) {
            setShowAllFacilities(localVal === 'true');
            return;
        }

        if (!user) return;

        setShowAllFacilities(user.userType !== 'PharmacyUser');
    }, [user]);

    useEffect(() => {
        try {
            localStorage.setItem('widget_showAllFacilities_Show', showAllFacilities ? 'true' : 'false');
        } catch (err) {
            console.debug('Could not persist widget_showAllFacilities_Show to localStorage', err);
        }
    }, [showAllFacilities]);

    return (
        <ShowAllFacilitiesContext.Provider value={{ showAllFacilities, setShowAllFacilities }}>
            {props.children}
        </ShowAllFacilitiesContext.Provider>
    );
}
